import React from 'react';
import footerGFX from 'assets/hipaa.svg';
import { GOOGLE_RECAPTCHA_LINKS, MAIN_WEBSITE_LINKS } from 'utils/constants/general';

export const HCPSignupFooter = () => (
  <div className="hcp-signup-footer">
    <div>
      <img src={footerGFX} alt="text" />
    </div>
    <div className="hcp-signup-agreement">
      {'By clicking "Save" I agree to the '}
      <a className="link" href={MAIN_WEBSITE_LINKS.TERMS} target="_blank" rel="noopener noreferrer">
        Terms
      </a>
      {' and '}
      <a className="link" href={MAIN_WEBSITE_LINKS.PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      {' . '}
      <br />
      {' This site is protected by reCAPTCHA and the '}
      <a className="link" href={GOOGLE_RECAPTCHA_LINKS.GOOGLE_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
        Google Privacy Policy
      </a>
      {' and '}
      <a className="link" href={GOOGLE_RECAPTCHA_LINKS.GOOGLE_TERM_OF_SERVICE} target="_blank" rel="noopener noreferrer">
        Term of Service
      </a>
      {' apply. '}
    </div>
  </div>
);
